// extracted by mini-css-extract-plugin
export default {"departments":"OI-z","departmentHeading":"PI-z","departmentSection":"QI-z","departmentName":"RI-z","departmentLink":"SI-z","expandIcon":"TI-z"};